document.addEventListener('DOMContentLoaded', function () {
  function measureOptionTextWidth(selectEl, text) {
    const style = window.getComputedStyle(selectEl);
    const canvas = measureOptionTextWidth.canvas || (measureOptionTextWidth.canvas = document.createElement('canvas'));
    const ctx = canvas.getContext('2d');
    if (!ctx) return text.length * 8;

    ctx.font = [
      style.fontStyle,
      style.fontWeight,
      style.fontSize,
      style.fontFamily
    ].join(' ');

    const letterSpacing = parseFloat(style.letterSpacing) || 0;
    const baseWidth = ctx.measureText(text).width;
    const trackingWidth = Math.max(0, text.length - 1) * letterSpacing;

    return baseWidth + trackingWidth;
  }

  new Swiper('.you-may-also-like__swiper', {
    slidesPerView: 2.1,
    spaceBetween: 8,
    navigation: {
      nextEl: '.you-may-also-like__nav-next',
      prevEl: '.you-may-also-like__nav-prev',
    },
    pagination: false,
    scrollbar: false,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      }
    }
  });

  document.querySelectorAll('.smallcaps.text-xxs.text-subdued').forEach(function (el) {
    el.textContent = el.textContent.replace(/[()]/g, '');
  });

  document.querySelectorAll('.you-may-also-like__item form').forEach(function (form) {
    const variantSelect = form.querySelector('.you-may-also-like__variant-select');
    const selectedLabel = form.querySelector('.you-may-also-like__variant-selected-label');

    if (!variantSelect || !selectedLabel) return;

    const syncSelectedLabel = function () {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) return;

      const optionText = selectedOption.textContent.trim();
      const helperText = optionText.includes('/')
        ? optionText.split('/').slice(1).join('/').trim()
        : optionText;
      const style = window.getComputedStyle(variantSelect);
      const paddingLeft = parseFloat(style.paddingLeft) || 0;
      const paddingRight = parseFloat(style.paddingRight) || 0;
      const arrowSpace = 22;
      const availableTextSpace = Math.max(0, variantSelect.clientWidth - paddingLeft - paddingRight - arrowSpace);
      const optionTextWidth = measureOptionTextWidth(variantSelect, optionText);
      const selectTextIsTruncated = optionTextWidth > availableTextSpace;

      const formRect = form.getBoundingClientRect();
      const selectRect = variantSelect.getBoundingClientRect();
      const selectOverflowsCard = (selectRect.width - formRect.width) > 1 || selectRect.left < formRect.left || selectRect.right > formRect.right;
      const shouldShowHelper = selectTextIsTruncated || selectOverflowsCard;

      selectedLabel.textContent = helperText;
      variantSelect.setAttribute('title', optionText);
      form.classList.toggle('has-long-variant', shouldShowHelper);
    };

    syncSelectedLabel();
    variantSelect.addEventListener('change', syncSelectedLabel);
    window.addEventListener('resize', syncSelectedLabel);
  });

});